
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";

export const CloseSettings = () => {
  const [apiKey, setApiKey] = useState("");
  const [autoSync, setAutoSync] = useState(true);
  const [syncInterval, setSyncInterval] = useState(60);
  const { toast } = useToast();
  
  const handleSave = () => {
    // Simulate saving settings
    toast({
      title: "Einstellungen gespeichert",
      description: "Die Close CRM Einstellungen wurden erfolgreich gespeichert."
    });
  };
  
  return (
    <div className="grid gap-6 max-w-4xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>API Konfiguration</CardTitle>
          <CardDescription>Verwalten Sie Ihre Close CRM API-Zugangsdaten</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="apiKey">API Key</Label>
            <Input
              id="apiKey"
              placeholder="Ihr Close CRM API-Key"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              type="password"
            />
            <p className="text-sm text-gray-500">
              Der API-Key wird verschlüsselt gespeichert und für API-Anfragen verwendet
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Synchronisierungseinstellungen</CardTitle>
          <CardDescription>Legen Sie fest, wie Daten zwischen Close CRM und Ihrer Plattform synchronisiert werden</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <Label htmlFor="autoSync">Automatische Synchronisation</Label>
              <p className="text-sm text-gray-500">
                Synchronisiert automatisch Daten in regelmäßigen Abständen
              </p>
            </div>
            <Switch
              id="autoSync"
              checked={autoSync}
              onCheckedChange={setAutoSync}
            />
          </div>
          
          {autoSync && (
            <div className="space-y-2">
              <Label htmlFor="syncInterval">Synchronisierungsintervall (Minuten)</Label>
              <Input
                id="syncInterval"
                type="number"
                min={5}
                max={1440}
                value={syncInterval}
                onChange={(e) => setSyncInterval(parseInt(e.target.value) || 60)}
              />
            </div>
          )}
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Datenzuordnung</CardTitle>
          <CardDescription>Konfigurieren Sie, wie Felder zwischen Close CRM und Meta Ads zugeordnet werden</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-600">
            Die Standardzuordnung ordnet Meta-Leads automatisch den entsprechenden Close CRM-Leads zu.
            Erweiterte Zuordnungen können auf Anfrage konfiguriert werden.
          </p>
        </CardContent>
      </Card>
      
      <CardFooter>
        <Button onClick={handleSave}>Einstellungen speichern</Button>
      </CardFooter>
    </div>
  );
};
